module.exports = __webpack_public_path__ + "static/media/oolongtea.92299f6f.jpg";